import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "../lib/site";

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <div data-testid="faq-page" className="pt-32">
      <section className="max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24 text-center">
        <div className="text-[11px] uppercase tracking-luxe text-gold mb-6">Answers</div>
        <h1 className="font-serif text-5xl md:text-7xl leading-[0.95]">Frequently<br/><span className="italic">Asked.</span></h1>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <div className="border-t border-taupe/50">
            {FAQS.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={i} data-testid={`faq-item-${i}`} className="border-b border-taupe/50">
                  <button
                    data-testid={`faq-toggle-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full py-6 md:py-8 flex items-center justify-between text-left group"
                  >
                    <span className="font-serif text-2xl md:text-3xl pr-6 group-hover:text-gold transition-colors">{f.q}</span>
                    <span className="w-8 h-8 border border-matte/40 flex items-center justify-center flex-shrink-0">
                      {isOpen ? <Minus size={14} /> : <Plus size={14} />}
                    </span>
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-500 ${isOpen ? "max-h-96 opacity-100 pb-8" : "max-h-0 opacity-0"}`}
                  >
                    <p className="text-matte/70 leading-relaxed text-base font-light max-w-2xl">{f.a}</p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mt-16 text-center">
            <div className="text-[11px] uppercase tracking-luxe text-gold mb-3">Still have questions?</div>
            <div className="font-serif text-3xl">We'd love to hear from you.</div>
            <Link data-testid="faq-contact-cta" to="/contact" className="mt-8 inline-block px-10 py-4 bg-matte text-gold border border-gold/40 text-[11px] uppercase tracking-luxe-sm hover:bg-black transition-colors">Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
